export const DEFAULT_COLOR = "red";
